export const SITES_API = '/api/v1/sites';
